<template>
  <div class="goodsManagePage">
    <div class="banner">
      <img src="../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>

    <div class="input_wrap flex-rowl">
      <div class="input_box search">
        <van-field
          v-model="params.keyword"
          ref="input"
          placeholder="输入商品关键字查找"
          @focus="handleFocus"
          @blur="handleBlur"
          @keyup.enter="handleSearch"
        />
      </div>
      <div class="primary-button" @click="handleSearch">查找→</div>
    </div>

    <div class="input_tip flex-rowc">
      <span>请查看搜索结果</span>
      <div class="btn" @click="handleSearch">显示全部</div>
    </div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div class="item_card" v-for="item in dataList" :key="item.id">
          <!-- <div class="block" @click="handleEdit(item.id)">
            <h1>商品ID：{{ item.id }}</h1>
          </div> -->
          <div class="block" @click="handleEdit(item.id)">
            <h1>商品名称：{{ item.commodityname }}</h1>
            <p>{{ item.commodityname_e }}</p>
            <p>{{ item.commodityname_y }}</p>
            <p>{{ item.commodityname_m }}</p>
            <p>{{ item.commodityname_t }}</p>
          </div>
          <div class="img_box" @click="handleEdit(item.id)">
            <!-- <img :src="item.img" alt="" /> -->
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="item.img"
            />
          </div>
          <div class="block" @click="handleEdit(item.id)">
            <p>企业名称：{{ item.qyname ? item.qyname : item.qy_accountid }}</p>
            <p>是否上架：{{ item.commoditystate }}</p>
            <p>销售状态：{{ item.salestate }}</p>
            <p>
              限购状态：<span v-if="item.islimit">{{
                item.islimit == "不限购"
                  ? item.islimit
                  : "每人限购/" + item.limitnum + "件"
              }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              SKU采购编码：{{ item.sku }}
              <span
                class="copy_box"
                :data-clipboard-text="item.sku"
                @click="handleCopyBtn"
                ><i class="iconfont icon-fuzhi"></i
              ></span>
            </p>
            <p>品牌标签：{{ item.brandname ? item.brandname : "" }}</p>
            <p>
              ISBN编码：{{ item.ISBN }}
              <span
                class="copy_box"
                :data-clipboard-text="item.ISBN"
                @click="handleCopyBtn"
                ><i class="iconfont icon-fuzhi"></i
              ></span>
            </p>
          </div>

          <div class="operation" @click="handleEdit(item.id)">
            <p>
              添加日期：<span>{{ item.createdate | formatDate  }}</span>
            </p>
            <p>
              操作人员：<span>{{ item.createman }}</span>
            </p>
          </div>
          <div class="editBtn" @click="handleEdit(item.id)">管理商品信息→</div>
        </div>
      </div>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleAdd">新增商品</div>
    </div>
  </div>
</template>

<script>
import { getMenuAuthTwo, getCommondity, encryptstringadd } from "../../api/api";
import Clipboard from "clipboard";
import { mapState } from "vuex";
export default {
  name: "cManageIndex",
  data() {
    return {
      isShowTabbar: true,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      dataList: [],
      finished: false,
      refreshing: false,
      params: {
        Page: 1,
        PageSize: 10,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 2, // 1 上架 0 下架 2 全部 留空为上架
        qyid: 0,
      },
      listTotal: 0,
      loading: false, // 是否正在加载中
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      }else {
        return date
      }
    },
  },
   computed: {
    // shopItem
    ...mapState(["OPENID"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.params.qyid = userInfo.qy.id;
    } else {
      this.params.qyid = 0;
    }
    this.roleId = userInfo.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
  },
  mounted() {
    this.initData(); // 初始化加载数据
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    handleSearch() {
      this.params.Page = 1;
      this.dataList = [];
      this.initData();
    },
    initData() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getCommondity(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },

    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.Page += 1;
        this.initData();
      }
    },

    handleReturn() {
      history.back();
    },
    handleEdit(id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      // this.$router.push(`/commondityIndex/cManageDetail/${id}`);
      this.encryptstringadd("cManageDetail", { id });
    },
    handleAdd() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      // this.$router.push("/commondityIndex/addCommondity");
      this.encryptstringadd("addCommondity", '');
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },

      // 页面跳转之前对参数进行加密
   async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  padding-bottom: 420px;
  .input_wrap {
    padding: 20px 45px 30px;
    box-sizing: border-box;
    .primary-button {
      width: 145px;
      margin-left: 20px;
      font-size: 26px;
    }
  }
  .input_tip {
    font-size: 14px;
    margin-bottom: 60px;
    color: #aaaaaa;
    .btn {
      margin-left: 30px;
      background: #6e5c86;
      color: #fff;
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      border-radius: 5px;
    }
  }
  .main_content {
    width: 650px;
    margin: 60px auto 100px;
    .data_list {
      // padding-bottom: 320px;
      .item_card {
        border: 2px solid #dedede;
        border-radius: 30px;
        padding: 45px 37px 87px;
        box-sizing: border-box;
        font-size: 22px;
        color: #404d6c;
        position: relative;
        margin-bottom: 55px;
        .block {
          margin-bottom: 30px;
        }
        .img_box {
          width: 250px;
          height: 250px;
          margin: 35px auto;
          background: #f8f8f8;
          overflow: hidden;
        }
        h1 {
          font-size: 30px;
          color: #404d6c;
          margin-bottom: 12px;
        }
        p {
          margin-bottom: 10px;
        }
        .editBtn {
          width: 200px;
          height: 50px;
          background: #6e5c86;
          border-radius: 25px;
          text-align: center;
          line-height: 50px;
          font-size: 20px;
          color: #fff;
          position: absolute;
          right: 20px;
          bottom: 20px;
        }
      }
    }
  }
}
</style>